import { ClockCounterClockwise } from "@phosphor-icons/react";
import { EmptyState } from "../shared/EmptyState";

export const RecentResultsPanel = () => {
  return (
    <div data-testid="panel-recent-results" className="rounded-lg border border-white/10 bg-eb-surface p-4">
      <h3 className="mb-3 font-heading text-lg uppercase tracking-tight text-white">Recent Results</h3>
      <EmptyState
        icon={ClockCounterClockwise}
        title="No Historical Results Yet"
        description="Settled bets and model accuracy history will populate here over time."
        testId="empty-state-recent-results"
      />
    </div>
  );
};
